import store from '@/store'

const state = {
  user: null,
}

const getters = {

}

const mutations = {
  // eslint-disable-next-line no-shadow
  SET_AUTH_USER(state, payload) {
    state.user = payload
    localStorage.setItem('userData', JSON.stringify(payload))
  },
}

const actions = {
  me: async ({ commit }) => {
    try {
      const data = await window.http.get('auth/me?include=current_promotion')
      if (data.error) {
        return null
      }

      await localStorage.setItem('userData', JSON.stringify(data))

      if (data.current_prize_draw && data.current_prize_draw.processing && data.uuid === data.current_prize_draw.processed_by.uuid) {
        await localStorage.setItem('prize-draw-processing', JSON.stringify(data.current_prize_draw))
        await store.dispatch('prizeDraw/setPrizeDrawInProcess', data.current_prize_draw)
      }
      commit('SET_AUTH_USER', data)
      return data
    } catch (error) {
      return error
    }
  },
  setUser: async ({ commit }, user) => {
    commit('SET_AUTH_USER', user)
    localStorage.setItem('userData', JSON.stringify(user))
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
